export default __webpack_public_path__ + "static/media/pokedexVanilla.76471dad.png";